/**
 * @classdesc Math系のユーティリティクラス
 */
export default class MathUtils {

    /**
     * 指定した範囲内でランダムな数値を取得
     * @param {number} min - 生成する数値の最小値
     * @param {number} max - 生成する数値の最大値
     * @param {number} [digit] - 小数点以下の桁数（省略時は整数）
     * @returns {number} ランダムな数値（digit指定時は小数）
     */
    static getRandom(min, max, digit) {
        let num = Math.random() * (max - min + 1) + min;
        num = digit ? Math.floor(num * Math.pow(10, digit)) / Math.pow(10, digit) : Math.floor(num);

        return num;
    }
}
